<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="header">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio1 || (showdettaglio5 && showdettaglio6)) && showdettaglio3">

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="socio">Socio:</label></b-col>
                                    <b-col sm="9">                                        
                                        <b-form-input v-model="socioVis" id="socio" type="text" disabled></b-form-input>                                           
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.id_evento != null">
                                    <b-col sm="3"><label for="evento">Evento:</label></b-col>
                                    <b-col sm="9">                                        
                                        <b-form-input v-model="eventoVis" id="evento" type="text" disabled></b-form-input>                                           
                                    </b-col>
                                </b-row>
                         
                                <b-row  class="my-1">
                                    <b-col sm="3"><label for="importo">Importo:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="pagamento.importo" id="importo" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.datapagamento != null">
                                    <b-col sm="3"><label for="datapagamento">Data pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="pagamento.datapagamento" id="datapagamento" type="date"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="metodopagamento">Metodo pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :disabled="parametri.flgpagamenti != 'S'" v-model="pagamento.metodopagamento" id="metodopagamento" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-show="pagamento.gatewaytransid != ''">
                                    <b-col sm="3"><label for="gatewaytransid">ID transazione pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="pagamento.gatewaytransid" id="gatewaytransid" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea :disabled="parametri.flgpagamenti != 'S'" id="note" v-model="pagamento.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flgatt">Attivo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select :disabled="parametri.flgpagamenti != 'S'" v-model="pagamento.flgatt" :options="options_attivo" id="flgatt">

                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="pagamento.datains" id="datains" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="pagamento.uteins" id="uteins" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.id != null">
                                    <b-col sm="3"><label for="datamod">Data modifica:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="pagamento.datamod" id="datamod" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="pagamento.id != null">
                                    <b-col sm="3"><label for="utemod">Utente modifica:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="pagamento.utemod" id="utemod" type="text"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-3" v-if="parametri.flgpagamenti == 'S'">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="pagamento.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>



</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Partecipa,
    Categoria,
    Socio,
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {                        
            namespace: NAMESPACE, 
            pagamento: {
                id: this.$route.params.id,
                id_evento: this.$route.params.id_evento,
                id_socio: this.$route.params.id_socio,
                id_partecipa: this.$route.params.id_partecipa,
                id_prenotazione: this.$route.params.id_prenotazione,
                importo: 0,
                datapagamento: '',
                metodopagamento: '',
                note: '',
                gatewaytransid: '',
                flgatt: 'S',
                datains: null,
                datamod: null,
                uteins: '',
                utemod: '',
                titoloscheda: '',
                cognomesocio: '',
                nomesocio: '',
                accountsocio: '',
            },            
            parametri: null,
            options: [],
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio3: false,
            showdettaglio5: false,
            showdettaglio6: false,
            datamin: null,
            datamax: null,
            dismissSecs: 2,
            dismissCountDown: 0,                      
        };
    },
    computed:{
        header: {
            // getter
            get: function () {
                var aux = "";
                if(this.pagamento.id == null){
                    aux += "Nuovo pagamento";                    
                }
                else{
                    aux += "Pagamento #" + this.pagamento.id;
                } 
                
                if(this.pagamento.id_evento != null){
                    aux += ' - Evento #' + this.pagamento.id_evento;
                }
                if(this.pagamento.id_socio != null){
                    aux += ' - Socio #' + this.pagamento.id_socio;
                }
                if(this.pagamento.id_prenotazione != null){
                    aux += ' - Prenotazione #' + this.pagamento.id_prenotazione;
                }
                if(this.pagamento.id_partecipa != null){
                    aux += ' - Partecipazione #' + this.pagamento.id_partecipa;
                }

                return aux;                
            },
            // setter
            set: function (newValue) {

            }
        },
        socioVis: {
            // getter
            get: function () {
                if(this.pagamento.id_socio == null || this.pagamento.id_socio == 'null' || parseInt(this.pagamento.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.pagamento.cognomesocio + " " + this.pagamento.nomesocio + " - " + this.pagamento.accountsocio;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
        eventoVis: {
            // getter
            get: function () {
                if(this.pagamento.id_evento == null || this.pagamento.id_evento == 'null' || parseInt(this.pagamento.id_evento) <= 0){
                    return '';
                }
                else{
                    return this.pagamento.titoloscheda;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
    },
    methods: {  
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        }, 
        insert() {

                var appdettaglio = this;

                if (this.pagamento.metodopagamento == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo metodo pagamento vuoto!";

                } else if (this.pagamento.datapagamento == "" || parseInt(this.pagamento.datapagamento) == 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data pagamento vuoto!";

                } else if (this.pagamento.importo <= 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo importo deve essere maggiore di 0!";

                } else {

                    var json = JSON.stringify(this.pagamento);

                    //console.log(json);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/pagamento', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.pagamento = res[0];
                                        this.showerror = false;
                                        this.showdettaglio1 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$router.replace('/app/dettagliopagamento/' + this.pagamento.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }

            }

    },
    created: function () {   
        
        

            if(!ctrlVismenu("P")){
                this.$router.replace('/accessdenied');
                return;
            }


            var id = this.pagamento.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/pagamenti/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.pagamento = res[0];
                                    this.pagamento.titoloscheda = res[0].titoloevento;
                                    this.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }
            else{

                var token = localStorage.getItem('token');   
                
                if(this.pagamento.id_evento != null){

                    this.axios.get(NAMESPACE + 'rest/eventi/' + this.pagamento.id_evento, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.pagamento.titoloscheda = res[0].titolo;
                                        this.showdettaglio5 = true;

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                    }
                    else{
                        this.showdettaglio5 = true;
                    }

                    this.axios.get(NAMESPACE + 'rest/soci/' + this.pagamento.id_socio, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.pagamento.accountsocio = res[0].email;
                                    this.pagamento.nomesocio = res[0].nome;
                                    this.pagamento.cognomesocio = res[0].cognome;
                                    this.showdettaglio6 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }
            
            //PAREMETRI
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            

    },
        mounted: function() {
            
          
            
        }

}
</script>
